import React, { Component } from 'react';
import classNames from 'classnames';
import Styles from './TextArea.cssmodule.less';

class TextArea extends Component {
    static REF = 'textareaRef'

    constructor(props) {
        super(props);
        this.state = {
            placeholderVisible: !this.props.children,
        };
    }

    handlePlaceholderClick = (e) => {
        e.preventDefault();
        e.stopPropagation();

        this.refs[TextArea.REF].focus();
    };

    handleChange = (e) => {
        this.setState({ placeholderVisible: !e.target.value });
        if (this.props.onValueChange) {
            this.props.onValueChange(e.target.value);
        }
    };

    render() {
        const {
            className,
            children,
            placeholder,
            ...restProps
        } = this.props;
        const {
            placeholderVisible,
        } = this.state;

        return (
            <div className={Styles.wrapper}>
                <textarea
                    ref={TextArea.REF}
                    className={className}
                    onInput={this.handleChange}
                    {...restProps}
                >
                    {children}
                </textarea>
                {placeholderVisible && (
                    <div
                        className={classNames(Styles.placeholder, className)}
                        onClick={this.handlePlaceholderClick}
                    >
                        {placeholder}
                    </div>
                )}
            </div>
        );
    }
}

TextArea.displayName = 'TextArea';
TextArea.propTypes = {};

export default TextArea;



// WEBPACK FOOTER //
// ./components/CommonSet/TextArea.js